export enum Role {
    None = 0,
    Individual = "Individual",
    Foreign = "Foreign",
    Private = "Private",
    GStaff = 3
}